// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11wPI","newExpiryDate":"styles_newExpiryDate__1JmIc","footer":"styles_footer__1BMkq"};